/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Select, Form, Input, Checkbox } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DokanCard from '../card/DokanCard';
import DokanTextInputField from '../form/DokanTextInputField';
import DokanInputLabel from '../form/DokanInputLabel';
import DokanCheckBox from '../form/DokanCheckBox';
import { handleProductInput } from '../../redux/products/productsActions';
import { fetchPreferences } from '../../redux/settings/settingsActions';

function Inventory() {
    // eslint-disable-next-line camelcase
    const stock_status = [
        { value: 'instock', name: 'In Stock' },
        { value: 'outofstock', name: 'Out of Stock' },
        { value: 'onbackorder', name: 'On backOrder' },
    ];
    const backOrder = [
        { value: 'no', name: 'No' },
        { value: 'yes', name: 'Yes' },
    ];
    const options = stock_status.map((d) => <Select.Option key={d.value}>{d.name}</Select.Option>);
    const backOrderoptions = backOrder.map((d) => (
        <Select.Option key={d.value}>{d.name}</Select.Option>
    ));

    const dispatch = useDispatch();
    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleProductInput(name, value, e));
    };
    const getInputData = useSelector((state) => state.products.productInputData);
    const setInputData = getInputData.stock_status;
    const setbackOrderInputData = getInputData.backorders;
    const setSoldIndividualData = getInputData.sold_individually;

    const { preferences } = useSelector((state) => state.settings);
    const { productInputData } = useSelector((state) => state.products);
    useEffect(() => {
        dispatch(fetchPreferences());
    }, [dispatch]);

    return (
        <>
            <DokanCard hasTitle hasDivider cardTitle="Inventory" hasSvg svgIcon="#product_general">
                <DokanInputLabel metaLabel="(Stock keeping unit)" isIcon icon="#checkbox_info">
                    SKU
                </DokanInputLabel>
                <DokanTextInputField
                    FormInputName="sku"
                    FormItemLabel="SKU"
                    onValueChange={handleChangeInput}
                />
                {preferences.stock_management === 'yes' && (
                    <>
                        <DokanInputLabel isIcon icon="#checkbox_info">
                            Manage Stock
                        </DokanInputLabel>
                        <DokanCheckBox
                            label="Enable stock management at product level"
                            FormInputName="manage_stock"
                            FormItemLabel=""
                            onValueChange={handleChangeInput}
                        />
                    </>
                )}
                {productInputData.manage_stock && (
                    <fieldset>
                        <legend> Manage Stock </legend>
                        <DokanInputLabel isIcon icon="#checkbox_info">
                            Stock Quantity
                        </DokanInputLabel>
                        <DokanTextInputField
                            FormInputName="stock_quantity"
                            onValueChange={handleChangeInput}
                        />
                        <DokanInputLabel isIcon icon="#checkbox_info">
                            Allow Backorder
                        </DokanInputLabel>
                        <Form.Item name="backorders">
                            <Select
                                className="mt-20px dokan-select"
                                showArrow
                                style={{ width: '100%' }}
                                onChange={(value) => handleChangeInput('backorders', value)}
                                placeholder="Allow Backorders"
                                value={setbackOrderInputData}
                                defaultValue={setbackOrderInputData}
                            >
                                {backOrderoptions}
                            </Select>
                        </Form.Item>
                        <DokanInputLabel isIcon icon="#checkbox_info">
                            Low Stock Thrashold
                        </DokanInputLabel>
                        <DokanTextInputField
                            placeholder="0"
                            FormInputName="low_stock_thrashold"
                            onValueChange={handleChangeInput}
                        />
                    </fieldset>
                )}
                <DokanInputLabel isIcon icon="#checkbox_info">
                    Stock Status
                </DokanInputLabel>

                <Form.Item name="stock_status">
                    <Select
                        className="mt-20px dokan-select"
                        showArrow
                        style={{ width: '100%' }}
                        onChange={(value) => handleChangeInput('stock_status', value)}
                        placeholder="Select Stock Status"
                        value={setInputData}
                        defaultValue={setInputData}
                    >
                        {options}
                    </Select>
                </Form.Item>

                <DokanInputLabel isIcon icon="#checkbox_info">
                    Sold Individually
                </DokanInputLabel>
                {/* <DokanCheckBox
                    label="Enable this to only allow one of this item to be bought in a single order."
                    value="sold_individually"
                    FormInputName="individual_sale"
                    onValueChange={handleChangeInput}
                /> */}
                <Form.Item name="sold_individually">
                    <div className="grid gap-y-1 justify-between min-w-full">
                        <div className="flex flex-1 pt-4">
                            <div>
                                <Checkbox
                                    className="dokan-checkbox"
                                    defaultChecked={setSoldIndividualData}
                                    onChange={(e) =>
                                        handleChangeInput('sold_individually', e.target.checked)
                                    }
                                >
                                    <span className="text-sm font-light">
                                        Enable this to only allow one of this item to be bought in a
                                        single order.
                                    </span>
                                </Checkbox>
                            </div>

                            {/* <div className="mt-1">
                                <DokanIcons icon="#checkbox_info" size="3" />
                            </div> */}
                        </div>
                    </div>
                </Form.Item>
            </DokanCard>
        </>
    );
}

export default Inventory;
